<div class="message-area">
  <h1><span>401</span></h1>
  <h1>Unauthorized</h1>
  <h2>アクセスしようとしたページは表示できませんでした。</h2>
  <p class="explain">このエラーは、必要な権限が不足している状態で、<br />
    ページ閲覧を行おうとしたことを意味します。</p>
    <h3>以下のような原因が考えられます。</h3>
    <div id="white_box">
        <div id="cause">
            <ul>
                <li>認証したユーザーが間違っている。</li>
                <li>認証したユーザーに正しい権限が付与されていない。</li>
            </ul>
        </div>
    </div>
</div>
